import Cookies from 'js-cookie'
import type { UserInfo } from '../type/user.type'

const ADV_ID_KEY = '__adv_id'
export const advId = {
  set(id: UserInfo['id']): ReturnType<typeof Cookies.set> {
    return Cookies.set(ADV_ID_KEY, String(id), { path: '/', expires: 30 })
  },
  get(): string | undefined {
    return Cookies.get(ADV_ID_KEY)
  },
  remove(): ReturnType<typeof Cookies.remove> {
    return Cookies.remove(ADV_ID_KEY)
  },
}

const ADV_CC_KEY = '__adv_cc'
export const advCC = {
  set(id: UserInfo['id']): ReturnType<typeof Cookies.set> {
    return Cookies.set(ADV_CC_KEY, String(id), { path: '/', expires: 30 })
  },
  get(): string | undefined {
    return Cookies.get(ADV_CC_KEY)
  },
  remove(): ReturnType<typeof Cookies.remove> {
    return Cookies.remove(ADV_CC_KEY)
  },
}

const ADV_NAME_KEY = '__adv_name'
export const advName = {
  set(name: UserInfo['username']): ReturnType<typeof Cookies.set> {
    return Cookies.set(ADV_NAME_KEY, String(name), { path: '/', expires: 30 })
  },
  get(): string | undefined {
    return Cookies.get(ADV_NAME_KEY)
  },
  remove(): ReturnType<typeof Cookies.remove> {
    return Cookies.remove(ADV_NAME_KEY)
  },
}
